var componentHelpers = {
  inlineTemplate: '<slot :vc="vc"></slot>' // can not be mixed in

};
export default componentHelpers;